import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { Fragment, ReactNode } from 'react';
import { Factbox, FactboxProps } from './Factbox';
import { FactboxBodyProps } from './Factbox.Body';
import { FactboxHeadlineProps } from './Factbox.Headline';
import { FactboxImagesProps } from './Factbox.Images';

export interface StandaloneFactboxProps extends StandaloneComponentProps {
  headline?: ReactNode;
  bodyText?: string;
  images?: JSX.Element[];
  options?: FactboxProps & {
    $headline?: FactboxHeadlineProps;
    $body?: FactboxBodyProps;
    $images?: FactboxImagesProps;
  };
}

export const StandaloneFactbox: StandaloneComponent<StandaloneFactboxProps> = ({
  headline,
  bodyText,
  images,
  options,
  ...props
}) => {
  const { $headline: headlineProps, $body: bodyProps, $images: imagesProps, ...baseProps } = options ?? {};

  return (
    <Factbox {...baseProps} {...props}>
      {headline && <Factbox.Headline {...headlineProps}>{headline}</Factbox.Headline>}
      {images && images.length > 0 && (
        <Factbox.Images {...imagesProps}>
          {images.map((image, index) => (
            <Fragment key={index}>{image}</Fragment>
          ))}
        </Factbox.Images>
      )}
      {bodyText && <Factbox.Body markup={bodyText} {...bodyProps} />}
    </Factbox>
  );
};

export default StandaloneFactbox;
